<template>
  <div class="home">
    <el-container class="out">
      <el-aside width="240px">
        <div class="logo" @click="toMain()">
          <img src="../assets/images/logo-min.png" />
          <p>智能配电监控云平台</p>
        </div>
        <div class="select">
          <i class="iconfont icon-iconfontzhizuobiaozhun0247"></i>
          <el-select v-model="projectId" @change="changeProject" placeholder="请选择">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId">
            </el-option>
          </el-select>
        </div>
        <el-menu :unique-opened=true :default-active="$route.path" :default-openeds="open_list" class="el-menu-vertical"
          router @click="selectItems" background-color="rgba(0,0,0,0)" text-color="#6B7CA7" active-text-color="#2A7AFF">
          <el-menu-item index="/all/general" v-if="resourceIds.indexOf('2') > -1" @click="closeItem">
            <i class="iconfont icon-leimupinleifenleileibie"></i>
            <span slot="title">概况总览</span>
          </el-menu-item>
          <el-submenu v-if="resourceIds.indexOf('3') > -1" index="2">
            <template slot="title">
              <i class="iconfont icon-icon_timesmonitoring_nor"></i>
              <span>实时监控</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/all/index" v-if="menuChildren.indexOf('151') > -1">组态监控</el-menu-item>
              <el-menu-item index="/all/jinxian" v-if="menuChildren.indexOf('152') > -1">进线监控</el-menu-item>
              <el-menu-item index="/all/bianyaqi" v-if="menuChildren.indexOf('153') > -1">变压器监控</el-menu-item>
              <el-menu-item index="/all/gaoyahuilu" v-if="menuChildren.indexOf('154') > -1">回路监控</el-menu-item>
              <el-menu-item index="/all/wenshidu" v-if="menuChildren.indexOf('155') > -1">环境监控</el-menu-item>
              <el-menu-item index="/all/shipin" v-if="menuChildren.indexOf('156') > -1">视频监控</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- <el-menu-item index="/all/report" v-if="resourceIds.indexOf('4') > -1" @click="closeItem">
            <i class="iconfont icon-baobiao"></i>
            <span slot="title">数据报表</span>
          </el-menu-item> -->
          <el-submenu v-if="resourceIds.indexOf('4') > -1" index="3">
            <template slot="title">
              <i class="iconfont icon-baobiao"></i>
              <span>数据报表</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/all/report" v-if="menuChildren.indexOf('171') > -1">数据报表(年月日)</el-menu-item>
              <el-menu-item index="/all/peak" v-if="menuChildren.indexOf('172') > -1">尖峰谷平统计</el-menu-item>
              <el-menu-item index="/all/monthReport" v-if="menuChildren.indexOf('173') > -1">综合报告</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/all/analysis" v-if="resourceIds.indexOf('12') > -1" @click="closeItem">
            <i class="iconfont icon-tongji"></i>
            <span slot="title">统计分析</span>
          </el-menu-item>
          <el-menu-item index="/all/event" v-if="resourceIds.indexOf('5') > -1" @click="closeItem">
            <i class="iconfont icon-jilu"></i>
            <span slot="title">事件记录</span>
          </el-menu-item>
          <el-menu-item index="/all/equipment" v-if="resourceIds.indexOf('6') > -1" @click="closeItem">
            <i class="iconfont icon-baobiao"></i>
            <span slot="title">设备管理</span>
          </el-menu-item>
          <el-menu-item index="/all/user" v-if="resourceIds.indexOf('7') > -1" @click="closeItem">
            <i class="iconfont icon-yonghu"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container class="main">
        <headerMain :showTitle="false"></headerMain>
        <!-- <el-header>
          <div class="right">
            <img src="../assets/images/person.png" />
            <p>欢迎 {{ name }}</p>
            <el-badge :value="customSysMsgUnread" v-show="customSysMsgUnread > 0" :max="99" class="item" @click="toWarn">
              <img src="../assets/images/icon/message.png" @click="toWarn" />
            </el-badge>
            <img src="../assets/images/icon/icon2.png" v-if="isOpenAdmin" @click="toAdmin" />
            <img src="../assets/images/icon/logout.png" @click="logout" />
          </div>
        </el-header> -->
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import headerMain from "../components/headerMain";
  // @ is an alias to /src
  export default {
    name: "Home",
    data () {
      return {
        projectList: [], //项目列表
        projectId: "1",
        name: "",
        customSysMsgUnread: 12,
        resourceIds: [],
        childrens: [],
        open_list: ["1"],
        openArray: [],
        isOpenAdmin: false,
      };
    },
    components: { headerMain },
    // computed: {
    //   menuChildren() {
    //     return this.$store.state.menuChildren;
    //   },
    // },
    created () {
      this.menuChildren = localStorage.getItem("menuSon").split(",");
      console.log(this.menuChildren);
      this.projectId = this.$getCookie("projectId") + "";
      this.name = JSON.parse(this.$getCookie("userInfo")).userName;
      // 项目列表
      this.getProjectList();
      this.resourceIds = this.$getCookie("resourceIds").split(",");
      console.log(this.resourceIds);
      let manageIds = ["8", "9", "10", "11", "99"];
      if (this.resourceIds.length > 0) {
        let that = this;
        that.isOpenAdmin =
          manageIds.filter(function (val) {
            return that.resourceIds.indexOf(val) > -1;
          }).length > 0
            ? true
            : false;
      } else {
        this.$router.push("/404");
      }
      // this.alarm(localStorage.code);
      // console.log(that.isOpenAdmin)
      // if (this.resourceIds.indexOf("99") > -1) {
      //   this.isOpenAdmin = true;
      // }
    },
    methods: {
      // 获取项目列表
      getProjectList () {
        let userInfo = this.$getCookie("userInfo");
        let id = JSON.parse(userInfo).userId;
        this.$http
          .post("bma-user-service/project/searchUserProjects", {
            userId: id,
          })
          .then((res) => {
            let num = 0;
            res.data.forEach((item) => {
              item.projectId = item.id + "";
              num++;
              item.mateId = num;
            });
            console.log(res.data);
            this.projectList = res.data;
          });
      },
      closeItem () {
        this.open_list = ["1"];
      },
      selectItems (index, path) {
        console.log("999999999999999999999999");
        console.log(index);
        console.log(path);
      },
      toMain () {
        this.$router.push("/project");
      },
      //
      handleOpen (key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose (key, keyPath) {
        console.log(key, keyPath);
      },
      changeProject (e) {
        document.cookie = "projectId=" + e;
        document.cookie = "roomId=";
        this.$store.commit("setRoomId", "");
        // console.log(this.projectList);
        // console.log(JSON.parse(this.$getCookie("userInfo")));
        this.projectList.forEach((item) => {
          if (item.projectId === e) {
            localStorage.code = "";
            // alert(item.mateId)
            // alert(JSON.stringify(JSON.parse(this.$getCookie("userInfo")).projectTopic[item.mateId-1]))
            // alert(JSON.parse(this.$getCookie("userInfo")).projectTopic[item.mateId-1].projectCode)
            localStorage.code = JSON.parse(
              this.$getCookie("userInfo")
            ).projectTopic[item.mateId - 1].projectCode;
            // alert(JSON.stringify(JSON.parse(this.$getCookie("userInfo")).projectTopic[item.mateId].projectCode))
            // localStorage.rId=(JSON.parse(this.$getCookie("userInfo")).projectTopic)[item.mateId]
            // this.projectCode()
            // alert(localStorage.rId)
            // localStorage.rId = item.mateId;
          }
        });
        if (this.$router.currentRoute.name == "general") {
          location.reload();
        } else {
          this.$router.replace({
            name: "general",
          });
        }
      },
      // alarm(projectCode) {
      //   alert(projectCode)
      //   // const userInfo = JSON.parse(this.$getCookie("userInfo"));
      //   // 解决id重复导致回调方法不执行
      //   // userInfo.projectTopic.forEach((item) => {
      //   this.$timeing("/topic/app/alarm/" + projectCode, "all11", (res) => {
      //     const body = JSON.parse(res.body);
      //     // 那一个随机数当作id
      //     // var id = Math.random() * 1000000000;
      //     this.$store.commit("setAlarmInfo", body);
      //     // setInterval(palyDing, 10 * 1000);
      //   });
      //   // });
      // },
      toAdmin () {
        this.$router.push("/super");
      },
      toWarn () {
        this.$router.push("/warn");
      },
      logout () {
        this.$http.post("/bma-auth-service/sys/signOut").then((res) => {
          this.$clearAllCookie();
          localStorage.stop = true;
          this.$router.push("/");
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .out {
    height: 100%;

    .el-aside {
      background: linear-gradient(180deg, #131c26 0%, #152f57 66%, #0e3c83 100%);
      font-size: 14px;
      position: fixed;
      z-index: 22;
      height: 100%;

      .logo {
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: center;
        border-bottom: 1px solid #000000;

        img {
          width: 26px;
          height: 26px;
          margin-right: 10px;
        }

        p {
          font-size: 16px;
          color: #ffffff;
          height: 78px;
          line-height: 78px;
          text-align: center;
          letter-spacing: 3px;
        }
      }

      .select {
        width: 100%;
        text-align: center;
        position: relative;
        margin: 26px 0;

        >i {
          position: absolute;
          top: 13.5px;
          left: 34px;
          color: rgba(255, 255, 255, 0.5);
          z-index: 1;
          font-size: 13px;
        }

        /deep/.el-select {
          width: 200px;
          border-radius: 5px;

          .el-input__inner {
            background: #3480ff;
            border: none;
            color: #fff;
            padding-left: 40px;
          }
        }
      }

      .el-menu {
        width: 240px;
        border-right: none;

        .el-menu-item {
          &.is-active {
            background-color: #111111 !important;
          }

          &:hover {
            background-color: #111111 !important;
          }
        }
      }

      li {
        font-size: 14px;
        padding-left: 30px;
        width: 240px;

        i {
          color: rgba(107, 124, 167, 1);
          margin-right: 10px;
          font-size: 20px;
        }

        &.is-active {
          i {
            color: rgb(42, 122, 255);
          }
        }
      }

      .el-menu-item-group {
        padding-left: 0px !important;
        background-color: #111111 !important;

        ul {
          li {
            padding-left: 49px !important;
            border-bottom: 1px solid rgb(0, 0, 0, 0.34);

            &:first-child {
              margin-top: -14px;
            }
          }
        }
      }

      li.el-submenu {
        font-size: 14px;
        padding-left: 30px;
        width: 240px;

        i {
          color: rgba(107, 124, 167, 1);
          margin-right: 10px;
          font-size: 20px;
        }

        &.is-active {

          i,
          span {
            color: rgb(42, 122, 255);
          }
        }

        &:nth-child(2) {
          padding-left: 0px !important;

          /deep/.el-submenu__title:hover,
          /deep/.el-submenu__title.is-active {
            background-color: #111111 !important;
          }
        }

        &:nth-child(3) {
          padding-left: 0px !important;

          /deep/.el-submenu__title:hover,
          /deep/.el-submenu__title.is-active {
            background-color: #111111 !important;
          }
        }
      }
    }
  }

  .main {
    /* overflow-y: scroll; */
    background: #ececec;

    .el-header {
      box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
      height: 78px;
      background: #fff;
      padding: 0 25px;
      display: flex;
      align-items: center;
      justify-content: flex-end; // width: calc( 100% - 230px);
      width: 100%;
      position: fixed;
      z-index: 10;

      .right {
        display: flex;
        align-items: center;

        img {
          cursor: pointer;
          width: 37px;
          margin-right: 20px;

          &:not(:first-of-type) {
            width: 30px;
            height: 30px;
          }
        }

        .el-badge {
          margin-right: 20px;

          img {
            width: 30px;
            height: 30px;
            cursor: pointer;
            margin: 0;
          }
        }

        p {
          line-height: 27px;
          color: #445a5a;
          margin-right: 20px;
        }
      }
    }

    .el-main {
      padding: 0px;
      background: #ececec;
      overflow: initial;
      margin-top: 60px;
      margin-left: 240px;
      height: calc(100% - 60px);
      width: calc(100% - 240px)
    }

    @media screen and (max-width: 1440px) {
      .el-main {
        width: 100%
      }
    }
  }

  .el-submenu__title {
    color: green;
    height: 200px;
  }
</style>